import PropTypes from "prop-types"
import classnames from "classnames"
import { get } from "lodash"
import { colorWithOpacity } from "helpers/colors"
import PositionTooltip from "components/position-tooltip"

function PositionsRow({ data, column: { color, noData, isUnmodeled }, index, item, isActive }) {
  let loading = !data[index] && !noData && !isUnmodeled
  const columnData = get(data, [index, "positions"])
  const { id, formatter, getEconomicExposures } = item
  const { economicExposure, basePercentEquity, positionPercentEquity } = getEconomicExposures(columnData, id)
  let value = !loading && !noData && !isUnmodeled && formatter(economicExposure)
  if (value === "Loading...") {
    loading = true
    value = ""
  }

  const style = loading
    ? { background: `linear-gradient(90deg, ${colorWithOpacity(color, 0.1)}, ${colorWithOpacity(color, 0.3)})` }
    : { backgroundColor: colorWithOpacity(color, 0.1) }

  return <div className={classnames({ loading })} style={style}>
    <PositionTooltip position={{ ...item, basePercentEquity, positionPercentEquity }} isActive={isActive}>
      {value}
    </PositionTooltip>
  </div>
}

PositionsRow.propTypes = {
  column: PropTypes.shape({
    id: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    noData: PropTypes.bool,
    isUnmodeled: PropTypes.bool,
  }).isRequired,
  index: PropTypes.number.isRequired,
  data: PropTypes.array.isRequired,
  isActive: PropTypes.bool.isRequired,
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    formatter: PropTypes.func.isRequired,
    getEconomicExposures: PropTypes.func.isRequired,
    // There are more props but they are used only in PositionTooltip
  }).isRequired,
}

export default PositionsRow
